import { render } from "./MainDashiew.vue?vue&type=template&id=c727e62a&scoped=true"
import script from "./MainDashiew.vue?vue&type=script&lang=js"
export * from "./MainDashiew.vue?vue&type=script&lang=js"

import "./MainDashiew.vue?vue&type=style&index=0&id=c727e62a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c727e62a"]])

export default __exports__